/* Spa & Glam Girls — global theme behaviors. All guarded; safe if elements absent. */
(function () {
  "use strict";
  var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    /* ---- Mobile menu ---- */
    var mm = document.querySelector(".sgg .mobile-menu");
    var hamb = document.querySelector(".sgg .hamb");
    if (mm && hamb) {
      var openMenu = function () { mm.classList.add("open"); hamb.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; };
      var closeMenu = function () { mm.classList.remove("open"); hamb.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; };
      hamb.addEventListener("click", openMenu);
      var mc = mm.querySelector(".mm-close");
      if (mc) mc.addEventListener("click", closeMenu);
      mm.addEventListener("click", function (e) { if (e.target === mm) closeMenu(); });
      mm.querySelectorAll("a").forEach(function (a) { a.addEventListener("click", closeMenu); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && mm.classList.contains("open")) closeMenu(); });
    }

    /* ---- Floating call button ---- */
    var fab = document.querySelector(".sgg .fab-call");
    if (fab) {
      var ticking = false;
      var upd = function () { if (window.scrollY > 480) fab.classList.add("show"); else fab.classList.remove("show"); ticking = false; };
      window.addEventListener("scroll", function () { if (!ticking) { window.requestAnimationFrame(upd); ticking = true; } }, { passive: true });
      upd();
    }

    /* ---- Scroll reveal ---- */
    if ("IntersectionObserver" in window && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      document.querySelectorAll(".sgg .reveal").forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll(".sgg .reveal").forEach(function (el) { el.classList.add("in"); });
    }

    /* ---- FAQ accordion ---- */
    document.querySelectorAll(".sgg .faq-item").forEach(function (item) {
      var btn = item.querySelector(".faq-q"), ans = item.querySelector(".faq-a");
      if (!btn || !ans) return;
      function setOpen(open) {
        item.classList.toggle("open", open);
        btn.setAttribute("aria-expanded", open ? "true" : "false");
        ans.style.maxHeight = open ? ans.scrollHeight + "px" : "0px";
      }
      setOpen(item.classList.contains("open"));
      btn.addEventListener("click", function () { setOpen(!item.classList.contains("open")); });
      window.addEventListener("resize", function () { if (item.classList.contains("open")) ans.style.maxHeight = ans.scrollHeight + "px"; });
    });

    /* ---- Product gallery ---- */
    document.querySelectorAll(".sgg .gallery").forEach(function (g) {
      var main = g.querySelector(".gallery-main-img");
      if (!main) return;
      g.querySelectorAll(".sgg-thumb").forEach(function (btn) {
        btn.addEventListener("click", function () {
          main.src = btn.getAttribute("data-full");
          g.querySelectorAll(".sgg-thumb").forEach(function (b) { b.classList.remove("active"); });
          btn.classList.add("active");
        });
      });
    });

    /* ---- Filter chips (packages + gallery) ---- */
    document.querySelectorAll(".sgg .filters").forEach(function (bar) {
      var scope = bar.closest("section") || document;
      var chips = bar.querySelectorAll(".chip");
      var items = scope.querySelectorAll(".pkg[data-cat], .sgg-lb-item[data-cat]");
      chips.forEach(function (chip) {
        chip.addEventListener("click", function () {
          chips.forEach(function (c) { c.setAttribute("aria-pressed", "false"); });
          chip.setAttribute("aria-pressed", "true");
          var f = chip.getAttribute("data-filter");
          items.forEach(function (p) { p.style.display = (f === "all" || p.getAttribute("data-cat") === f) ? "" : "none"; });
        });
      });
    });

    /* ---- Lightbox for galleries ---- */
    (function () {
      var groups = document.querySelectorAll(".sgg .sgg-lb");
      if (!groups.length) return;
      var ns = "http://www.w3.org/2000/svg";
      var ov = document.createElement("div");
      ov.className = "sgg-lbx";
      ov.setAttribute("role", "dialog");
      ov.setAttribute("aria-modal", "true");
      ov.setAttribute("aria-hidden", "true");
      ov.innerHTML =
        '<button class="sgg-lbx-close" type="button" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg></button>' +
        '<button class="sgg-lbx-prev" type="button" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
        '<figure><img alt=""><figcaption></figcaption></figure>' +
        '<button class="sgg-lbx-next" type="button" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg></button>';
      document.body.appendChild(ov);
      var img = ov.querySelector("img"), cap = ov.querySelector("figcaption");
      var items = [], idx = 0;
      function show(i) {
        if (!items.length) return;
        idx = (i + items.length) % items.length;
        var el = items[idx];
        img.src = el.getAttribute("data-full");
        var c = el.getAttribute("data-caption") || "";
        cap.textContent = c; cap.style.display = c ? "block" : "none";
      }
      function open(group, el) {
        items = Array.prototype.filter.call(group.querySelectorAll(".sgg-lb-item"), function (x) { return x.offsetParent !== null; });
        var i = items.indexOf(el); if (i < 0) i = 0;
        ov.classList.add("open"); ov.setAttribute("aria-hidden", "false");
        document.body.style.overflow = "hidden"; show(i);
      }
      function close() {
        ov.classList.remove("open"); ov.setAttribute("aria-hidden", "true");
        document.body.style.overflow = ""; img.src = "";
      }
      groups.forEach(function (g) {
        g.querySelectorAll(".sgg-lb-item").forEach(function (el) {
          el.addEventListener("click", function () { open(g, el); });
        });
      });
      ov.querySelector(".sgg-lbx-close").addEventListener("click", close);
      ov.querySelector(".sgg-lbx-prev").addEventListener("click", function () { show(idx - 1); });
      ov.querySelector(".sgg-lbx-next").addEventListener("click", function () { show(idx + 1); });
      ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
      document.addEventListener("keydown", function (e) {
        if (!ov.classList.contains("open")) return;
        if (e.key === "Escape") close();
        else if (e.key === "ArrowLeft") show(idx - 1);
        else if (e.key === "ArrowRight") show(idx + 1);
      });
      var sx = 0, sy = 0;
      ov.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      ov.addEventListener("touchend", function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) show(idx + 1); else show(idx - 1); }
      });
    })();

    /* ---- Testimonials carousel ---- */
    document.querySelectorAll(".sgg .tst-track").forEach(function (track) {
      var scope = track.closest("section") || document;
      var slides = track.children, total = slides.length;
      var dotsWrap = scope.querySelector(".tst-dots");
      if (!dotsWrap || total === 0) return;
      var idx = 0, timer = null, playing = !reduce;
      for (var i = 0; i < total; i++) {
        (function (i) {
          var b = document.createElement("button");
          b.type = "button"; b.setAttribute("role", "tab"); b.setAttribute("aria-label", "Review " + (i + 1) + " of " + total);
          b.addEventListener("click", function () { go(i); restart(); });
          dotsWrap.appendChild(b);
        })(i);
      }
      var dots = dotsWrap.children;
      function go(n) { idx = (n + total) % total; track.style.transform = "translateX(-" + (idx * 100) + "%)"; for (var j = 0; j < total; j++) dots[j].setAttribute("aria-current", j === idx ? "true" : "false"); }
      function next() { go(idx + 1); } function prev() { go(idx - 1); }
      function start() { if (reduce || !playing) return; stop(); timer = setInterval(next, 5500); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { if (playing) start(); }
      var nb = scope.querySelector(".tst-next"), pb = scope.querySelector(".tst-prev");
      if (nb) nb.addEventListener("click", function () { next(); restart(); });
      if (pb) pb.addEventListener("click", function () { prev(); restart(); });
      var pause = scope.querySelector(".tst-pause");
      if (pause) pause.addEventListener("click", function () { playing = !playing; pause.setAttribute("aria-pressed", playing ? "false" : "true"); var sp = pause.querySelector("span"); if (sp) sp.textContent = playing ? "Pause auto-play" : "Play auto-play"; if (playing) start(); else stop(); });
      var vp = track.parentElement;
      vp.addEventListener("mouseenter", stop); vp.addEventListener("mouseleave", restart);
      vp.addEventListener("focusin", stop); vp.addEventListener("focusout", restart);
      document.addEventListener("visibilitychange", function () { document.hidden ? stop() : restart(); });
      go(0); if (reduce && pause) pause.style.display = "none"; else start();
    });
  });
})();